// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, createSubscriber } from '@atlassian/react-sweet-state';
import { actions, type Actions } from './actions.tsx';
import { translationSummariesSelector } from './selectors.tsx';
import type { State, SubscribedState } from './types.tsx';

const initialState: State = {
	loading: false,
	error: undefined,
	data: {
		languageTranslationSummaries: [],
	},
	isDataInitialised: false,
};

const Store = createStore({ initialState, actions });

export const TranslationSummariesSubscriber = createSubscriber<
	State,
	Actions,
	SubscribedState,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	selector: translationSummariesSelector,
});

export const useTranslationSummaries = createHook(Store, {
	selector: translationSummariesSelector,
});
